import { Injectable } from '@angular/core'

@Injectable()
export class SegmentService {
  getInstance() {
    return (<any>window).analytics
  }
}
